import React from 'react';

import { IIconProps, TIconType } from '../interface';

const ExpandIcon: TIconType = (props?: IIconProps) => {
	return (
		<svg
			data-testid='expand-icon'
			fill='none'
			height='25'
			viewBox='0 0 24 25'
			width='24'
			{...props?.innerSvgProps}
		>
			<path
				d='M15.75 4.57812H19.5V8.32812'
				stroke='#2E2E6B'
				strokeLinecap='round'
				strokeLinejoin='round'
			/>
			<path
				d='M14.25 9.82812L19.5 4.57812'
				stroke='#2E2E6B'
				strokeLinecap='round'
				strokeLinejoin='round'
			/>
			<path
				d='M8.25 19.5781H4.5V15.8281'
				stroke='#2E2E6B'
				strokeLinecap='round'
				strokeLinejoin='round'
			/>
			<path
				d='M9.75 14.3281L4.5 19.5781'
				stroke='#2E2E6B'
				strokeLinecap='round'
				strokeLinejoin='round'
			/>
			<path
				d='M19.5 15.8281V19.5781H15.75'
				stroke='#2E2E6B'
				strokeLinecap='round'
				strokeLinejoin='round'
			/>
			<path
				d='M14.25 14.3281L19.5 19.5781'
				stroke='#2E2E6B'
				strokeLinecap='round'
				strokeLinejoin='round'
			/>
			<path
				d='M4.5 8.32812V4.57812H8.25'
				stroke='#2E2E6B'
				strokeLinecap='round'
				strokeLinejoin='round'
			/>
			<path
				d='M9.75 9.82812L4.5 4.57812'
				stroke='#2E2E6B'
				strokeLinecap='round'
				strokeLinejoin='round'
			/>
		</svg>
	);
};

export default ExpandIcon;
